import { Component } from 'react'
import { connect } from 'react-redux'
import { clearSubmitErrors } from 'redux-form'

import { trackEvent } from '@offerzen/pinata-shame'

import {
  fetchWorkHistory as reduxFetchWorkHistory,
  addBlankWorkHistoryItem as reduxAddBlankWorkHistoryItem,
  deleteBlankWorkHistoryItem as reduxDeleteBlankWorkHistoryItem,
  createWorkHistory as reduxCreateWorkHistory,
  updateWorkHistory as reduxUpdateWorkHistory,
  deleteWorkHistory as reduxDeleteWorkHistory,
  toggleWorkHistoryEdit as reduxToggleWorkHistoryEdit,
  searchCompanies as reduxSearchCompanies,
  searchRoles as reduxSearchRoles,
  submit as reduxSubmit,
} from '../../redux/modules/workHistory'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'

import { workHistoryList, hasWorkHistoryRecords, isAddingNewWorkHistory } from '../../selectors/workHistory'

class WorkExperience extends Component {
  componentDidMount() {
    this.props.updateProgress(74)
    this.trackUser()
    this.props.fetchWorkHistory()
  }

  trackUser = () => trackEvent('onboarding-work-experience-accessed')

  render() {
    const { children, ...rest } = this.props
    return children({ ...rest })
  }
}

const mapStateToProps = state => ({
  candidateId: state.candidate.id,
  candidate: state.candidate,
  loading: state.workHistory.fetching,
  workHistories: workHistoryList(state),
  hasWorkHistoryRecords: hasWorkHistoryRecords(state),
  isAddingNewWorkHistory: isAddingNewWorkHistory(state),
})

const mapDispatchToProps = dispatch => ({
  fetchWorkHistory: candidateId => dispatch(reduxFetchWorkHistory(candidateId)),
  addBlankWorkHistory: () => {
    const uniqueId = Date.now().toString()
    dispatch(reduxAddBlankWorkHistoryItem(uniqueId))
  },
  deleteBlankWorkHistory: tempId => dispatch(reduxDeleteBlankWorkHistoryItem(tempId)),
  createWorkHistory: (candidateId, data, resolve, reject) => dispatch(reduxCreateWorkHistory(candidateId, data, resolve, reject)),
  updateWorkHistory: (id, data, resolve, reject) => dispatch(reduxUpdateWorkHistory(id, data, resolve, reject)),
  deleteWorkHistory: (candidateId, id) => dispatch(reduxDeleteWorkHistory(candidateId, id)),
  toggleEditing: (id, editing) => dispatch(reduxToggleWorkHistoryEdit(id, editing)),
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
  searchCompanies: (id, term) => dispatch(reduxSearchCompanies(id, term)),
  searchRoles: (id, term) => dispatch(reduxSearchRoles(id, term)),
  clearErrors: () => dispatch(clearSubmitErrors('noWorkExperienceForm')),
  submitWorkExperience: (data, resolve, reject) => dispatch(reduxSubmit(data, resolve, reject)),
  trackWorkHistoryChange: (action, incomplete = undefined) => {
    trackEvent('Candidate: profile action', {
      source: 'onboarding',
      action,
      incomplete,
    })
  },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  addBlankWorkHistory: () => {
    dispatchProps.addBlankWorkHistory()
    dispatchProps.clearErrors()
  },
  fetchWorkHistory: () => dispatchProps.fetchWorkHistory(stateProps.candidateId),
  createWorkHistory: (data, resolve, reject) => dispatchProps.createWorkHistory(stateProps.candidateId, data, resolve, reject),
  updateWorkHistory: (id, data, resolve, reject) => {
    dispatchProps.updateWorkHistory(id, data, resolve, reject)
    dispatchProps.clearErrors()
    dispatchProps.trackWorkHistoryChange('updated work history')
  },
  deleteWorkHistory: data => {
    dispatchProps.deleteWorkHistory(stateProps.candidateId, data.id)
    dispatchProps.trackWorkHistoryChange('removed work history', data.missingInformation)
    dispatchProps.clearErrors()
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(WorkExperience)
